import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { NoDataIllustration } from './NoData';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const NoData = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <NoDataIllustration title={title} />
  </IllustrationWrapper>
);
